import React, { useContext, useState, memo } from 'react';
import _ from 'lodash';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { Global } from '../../App';
import './GlobalSetting.scss';
// switch lang
import {
  langCodeToString,
  langStringToFullLangName
} from '../../Share/Tools/switchLang';

/**
 *
 * @typedef {{title: string, langType: number}} item
 */
/**
 * @param {any} props
 * @param {item[]} props.options
 * @param {string} props.mode
 * @param {function} props.onClose
 *
 */

function LangSelector({ options, mode, onClose, onToggleLang }) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [toggle, setToggle] = useState(false);
  function handleMode(mode) {
    switch (mode) {
      case 'pc':
        return {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomLeftRadius: '6px',
          borderBottomRightRadius: '6px',
          backgroundColor: '#B69E60',
          border: 'none'
        };
      case 'mobile':
        return {
          borderRadius: '6px',
          backgroundColor: '#B69E60',
          border: 'none'
        };
      default:
        return {};
    }
  }
  return (
    <Dropdown
      className="LangSelector"
      isOpen={toggle}
      size="sm"
      toggle={() => {
        setToggle(curr => !curr);
        if (onToggleLang) {
          onToggleLang();
        }
      }}
    >
      <DropdownToggle caret className="p-2" style={handleMode(mode)}>
        <span className="ml-2 mr-3">
          {langStringToFullLangName(globalState.langType)}
        </span>
      </DropdownToggle>
      <DropdownMenu
        style={{
          right: globalState.device === 'mobile' ? 'auto' : 0,
          left: globalState.device === 'mobile' ? 0 : 'auto'
        }}
      >
        {options.map(e => (
          <DropdownItem
            key={e.langType}
            className={`change-lang-${langCodeToString(e.langType)}`}
            onClick={() => {
              dispatchGlobal({
                type: 'UPDATE',
                payload: [
                  { key: 'langType', val: langCodeToString(e.langType) }
                ]
              });
              onClose();
            }}
          >
            {e.title}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}

export default LangSelector;
